import { render, staticRenderFns } from "./restaurantWorker.vue?vue&type=template&id=fc046394&scoped=true&"
import script from "./restaurantWorker.vue?vue&type=script&lang=js&"
export * from "./restaurantWorker.vue?vue&type=script&lang=js&"
import style0 from "./restaurantWorker.vue?vue&type=style&index=0&id=fc046394&prod&lang=scss&"
import style1 from "./restaurantWorker.vue?vue&type=style&index=1&id=fc046394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc046394",
  null
  
)

export default component.exports